import { useState } from 'react';

const DISMISSED_KEY = 'linescore_ios_install_dismissed';

function isIOSSafari(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua);
  const isStandalone =
    'standalone' in navigator && (navigator as Record<string, unknown>).standalone;
  return isIOS && !isStandalone;
}

export function IOSInstallBanner() {
  const [dismissed, setDismissed] = useState(() => !!localStorage.getItem(DISMISSED_KEY));

  if (!isIOSSafari()) return null;
  if (dismissed) return null;

  const handleDismiss = () => {
    localStorage.setItem(DISMISSED_KEY, '1');
    setDismissed(true);
  };

  return (
    <div className="bg-linen border-b border-sand px-4 py-2.5 flex items-center justify-between gap-3">
      <div className="flex items-center gap-2 min-w-0">
        <svg
          className="w-4 h-4 text-gold-text flex-shrink-0"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>
        <p className="font-sans text-[12px] text-ink">
          Add The Linescore to your home screen to receive notifications.{' '}
          <span className="text-warm-gray">Tap Share → Add to Home Screen</span>
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="font-sans text-[11px] text-warm-gray hover:text-ink transition-colors flex-shrink-0"
      >
        Got it
      </button>
    </div>
  );
}
